import { render, staticRenderFns } from "./DataCardTable.vue?vue&type=template&id=1e01b681&scoped=true"
import script from "./DataCardTable.vue?vue&type=script&lang=js"
export * from "./DataCardTable.vue?vue&type=script&lang=js"
import style0 from "./DataCardTable.vue?vue&type=style&index=0&id=1e01b681&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e01b681",
  null
  
)

export default component.exports